import environment, { CheckoutFlow } from "../environment";

export const ShopApi = {
    getBulkUserAddToCart: `/rest/${environment().checkoutFlow}/V1/carts/:quoteId/items/batch`,
    getBulkItemsAddToCart: `/rest/${environment().checkoutFlow}/V1/carts/mine/items/batch`,
    getBulkGuestAddToCart: `/rest/${environment().checkoutFlow}/V1/guest-carts/:cartToken/items/batch`,
    getGuestShareCartMagento: `/rest/${environment().checkoutFlow}/V1/share-cart/:cartToken`,
    getUserShareCartMagento: `/rest/${environment().checkoutFlow}/V1/share-cart/mine`,
    getShopGuestShareCartMergeMagento: `/rest/${environment().checkoutFlow}/V1/share-cart/:cartToken`,
    getShopUserShareCartMergeMagento: `/rest/${environment().checkoutFlow}/V1/share-cart/mine`,
    loginUrl: "/login?cart=true",
    addToLoggedInCartMagento: (flow?: CheckoutFlow) => `/rest/${getCheckoutFlow(flow)}/V1/carts/mine/items`,
    loggedInCartItemsMagento: (flow?: CheckoutFlow) => `/rest/${getCheckoutFlow(flow)}/V1/carts/mine`,
    cudLoggedInCartItemsMagento: `/rest/${environment().checkoutFlow}/V1/carts/mine/items`,
    loggedInCartItemsMagentoMiniCart: `/rest/${environment().checkoutFlow}/V1/carts/mine/mini-cart`,
    loggedInCartItemsTotalsMagento: `/rest/${environment().checkoutFlow}/V1/carts/mine/totals`,
    getLoggedInEstimatedTaxMagento: `/rest/${environment().checkoutFlow}/V1/carts/mine/tax-estimate`,
    getShippingMethodsMagento: `/rest/${environment().checkoutFlow}/V1/carts/mine/estimate-shipping-methods`,
    setShippingMethodsMagento: `/rest/${environment().checkoutFlow}/V1/carts/mine/shipping-information`,
    getBraintreeTokenMagento: `/rest/${environment().checkoutFlow}/V1/braintree/client-token/mine`,
    deleteVaultedCardMagento: `/rest/${environment().checkoutFlow}/V1/braintree/credit-card/:creditCardUniqueId`,
    createPaymentInfo: `/rest/${environment().checkoutFlow}/V1/carts/mine/payment-information`,
    orderConfirmationDataMagento: `/rest/${environment().checkoutFlow}/V1/orders/mine/:orderId`,
    ordersHistoryMagento: `/rest/${environment().checkoutFlow}/V1/orders/mine`,
    ordersHistoryShopMagento: `/rest/${environment().checkoutFlow}/V1/shop/orders/mine`,
    getCartsCustomPriceMagento: `/rest/${environment().checkoutFlow}/V1/carts/mine/custom-price`,
    getSharpenProductMagento: `/rest/${environment().checkoutFlow}/V1/product/sharpen/:isbn10`,
    getVaultedCardPaymentNonceMagento: `/rest/${environment().checkoutFlow}/V1/braintree/payment-nonce`,
    countriesMagento: `/rest/${environment().checkoutFlow}/V1/directory/countries`,
    getAddressBookMagento: `/rest/${environment().checkoutFlow}/V1/person/address-book/seg`,
    addressSuggestionMagento: `/rest/${environment().checkoutFlow}/V1/address-validation/us/suggestions`,
    addressUSStreetValidationMagento: `/rest/${environment().checkoutFlow}/V1/address-validation/us/street-validation`,
    addressInternationalStreetValidationMagento: `/rest/${environment().checkoutFlow}/V1/address-validation/international/street-validation`,
    savePurchaseOrder: `/rest/${environment().checkoutFlow}/V1/carts/mine/purchase-order`,
}

export const getAddProductToWishlistsMagento = (wishListId: number, sku: string) => `${environment().magentoUrl}/rest/V1/wishlists/mine/${wishListId}/${sku}`;
export const getRemoveProductFromWishlistsMagento = (wishListId: number, wishListItemId: number) => `${environment().magentoUrl}/rest/V1/wishlists/mine/${wishListId}/${wishListItemId}`;
export const getAllWishlistMagento = () => `/rest/V1/wishlists/mine`;
export const getWishlistByWishlistIdMagento = (wishListId: number) => `/rest/V1/wishlists/mine/${wishListId}`;
export const getCreateWishListUrlMagento = () => `${environment().magentoUrl}/rest/V1/wishlists/mine`;
export const getDeleteWishlistsUrlMagento = (wishListId: number) => `${environment().magentoUrl}/rest/V1/wishlists/mine/${wishListId}`;
export const getEditWishListUrlMagento = (wishListId: number) => `${environment().magentoUrl}/rest/V1/wishlists/mine/${wishListId}`;
export const getWishListBySharingCodeUrlMagento = (sharingCode: string) => `${environment().magentoUrl}/rest/V1/wishlists/${sharingCode}`;
export const getOrderStatusUrlMagento = (cartId: string) => `${environment().magentoUrl}/rest/${environment().checkoutFlow}/V1/order-status/quote/${cartId}`;
export const getConnectLaunchUrlMagento = () => `${environment().magentoUrl}/rest/${environment().checkoutFlow}/V1/connect-launch-url/mine`;

export const RECAPTCHA_HEADER = 'CAPTCHA_TOKEN';

export const MAGENTO_RECAPTCHA_HEADER = 'X-ReCaptcha';

export const MINICART_SIZE = 3;

export const PARAM_ORDER_ID = 'orderId';

export const ISBN = 'isbn';

export const getMagentoSchoolAddressUrl = () => `${environment().magentoUrl}/rest/us/V1/instructor/address`;

export const postGetGuestCartTokenMagento = () => `/shop/rest/${environment().checkoutFlow}/V1/guest-carts`;

 // cud => Create, Update, Delete
export const cudCartMagento = (guestCartToken: string) => `/rest/${environment().checkoutFlow}/V1/guest-carts/${guestCartToken}/items`;

export const guestCartMagento = (guestCartToken: string) => `/rest/${environment().checkoutFlow}/V1/guest-carts/${guestCartToken}`;

export const getGuestEstimatedTaxMagento = (guestCartToken: string) => `/rest/${environment().checkoutFlow}/V1/guest-carts/${guestCartToken}/tax-estimate`;

export const getUserPromoCodeDiscountMagento = (promoCode: string, flow?: CheckoutFlow) => `/rest/${getCheckoutFlow(flow)}/V1/carts/mine/promo-code/${promoCode}`;

export const removeUserPromoCodeDiscountMagento = () => `/rest/${environment().checkoutFlow}/V1/carts/mine/promo-code`;

export const initializeCartMagento = () => `/rest/${environment().checkoutFlow}/V1/initialize-cart/mine`;

export const validateUserConnectLicenseMagento = (isbn: string) => `/rest/${environment().checkoutFlow}/V1/connect-looseleaf/${isbn}/validate/mine`;

const getCheckoutFlow = (flow?: CheckoutFlow) => flow ? flow : environment().checkoutFlow;
